module.exports = ".d3-chart {\n    width: 50%;\n}\n.d3-chart .axis path, .d3-chart .axis line {\n    stroke: #999;\n}\n.d3-chart .axis text {\n    fill: #999;\n}\n.co2savings{\n    width: 50%;\n}\n.chart-einsparung{\n    width: 60%;\n}\n.chart-einsparung img{\n    width: 100%;\n}\n.legende li{\n    list-style: none;\n    position: relative;\n}\n.legende li svg{\n    position: absolute;\n    top: 5px;\n    left: -40px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/home/home.component.css
// module id = ./src/app/chart/home/home.component.css
// module chunks = main